import * as Sentry from '@sentry/browser';

export function logError(error: unknown, context?: Record<string, string>): void {
    if (error instanceof Error) {
        Sentry.getActiveSpan()?.recordException(error);
        Sentry.captureException(error, context ? { data: context } : undefined);
    } else if (isSupabaseError(error)) {
        Sentry.getActiveSpan()?.recordException(fromSupabaseError(error));
        Sentry.captureException(fromSupabaseError(error), context ? { data: context } : undefined);
    } else {
        Sentry.captureMessage(JSON.stringify(error), 'error');
    }
}

export function logWarning(warning: unknown): void {
    Sentry.captureMessage(String(warning), 'warning');
}

export function isSupabaseError(error: unknown): error is SupabaseError {
    if (typeof error !== 'object') {
        return false;
    }

    return error != null && 'code' in error && !!error.code && 'message' in error;
}

function fromSupabaseError(error: SupabaseError): Error {
    const messageString = `[${error.code}] ${error.message} (HINT: ${error.hint ?? 'none'}) => Details: ${error.details}`;
    return new Error(messageString);
}

type SupabaseError = {
    code: string;
    details?: string;
    hint?: string;
    message: string;
};
